const ElevationSwatch: React.FC<{
    elevation: number;
    padding?: React.CSSProperties['padding'];
    margin?: React.CSSProperties['margin'];
    size?: React.CSSProperties['width'] & React.CSSProperties['height'];
}> = ({ elevation, size: set_size, ...css }) => {
    const size = set_size ?? 20;

    return (
        <svg
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                width: size,
                height: size,
                ...css,
            }}
        >
            <circle cx={2} cy={30} r={2} stroke="grey" />
            <line x1="2" y1="30" x2="30" y2="30" stroke="black" />
            <line
                x1="2"
                y1="30"
                x2="30"
                y2="30"
                stroke="black"
                style={{
                    transform: `rotate(${-elevation}deg)`,
                    transformOrigin: 'bottom left',
                }}
            />
            <line
                x1="26"
                y1="26"
                x2="30"
                y2="30"
                stroke="black"
                style={{
                    transform: `rotate(${-elevation}deg)`,
                    transformOrigin: 'bottom left',
                }}
            />
            <line
                x1="26"
                y1="34"
                x2="30"
                y2="30"
                stroke="black"
                style={{
                    transform: `rotate(${-elevation}deg)`,
                    transformOrigin: 'bottom left',
                }}
            />
        </svg>
    );
};

ElevationSwatch.displayName = 'ElevationSwatch';
export default ElevationSwatch;
